import * as React from 'react';
export const CYSvg = React.forwardRef(function CYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        fillRule: 'nonzero',
        d: 'M6.5 9a1.5 1.5 0 0 0 3 0h1A2.498 2.498 0 0 1 8 11.5 2.5 2.5 0 0 1 5.5 9h1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79A59',
        d: 'm6 6 4-1v2L6 8z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm1-10a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4Z',
      }),
    ),
  );
});
CYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CY = {
  category: 'flag',
  colorable: false,
  name: 'CY',
  svg: CYSvg,
};
